import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { DrawerProvider } from '../contexts/drawer-context';
import { InstantCheckoutStatusProvider } from '../contexts/instant-checkout-status-context';
import { AddressContextProvider } from '../contexts/address-context';
import { PaymentsContextProvider } from '../contexts/payments-context';

export const InstantCheckoutProvider = ({
  children,
  userId,
  customerAccountId,
}: {
  children: React.ReactNode;
  userId: string;
  customerAccountId: string;
}) => {
  return (
    <QueryProvider cacheKey="instantCheckoutProvider">
      <InstantCheckoutStatusProvider
        userId={userId}
        customerAccountId={customerAccountId}
      >
        <QueryProvider cacheKey="instantCheckoutAddressProvider">
          <AddressContextProvider
            userId={userId}
            customerAccountId={customerAccountId}
          >
            <QueryProvider cacheKey="instantCheckoutPaymentsProvider">
              <PaymentsContextProvider
                userId={userId}
                customerAccountId={customerAccountId}
              >
                <DrawerProvider>{children}</DrawerProvider>
              </PaymentsContextProvider>
            </QueryProvider>
          </AddressContextProvider>
        </QueryProvider>
      </InstantCheckoutStatusProvider>
    </QueryProvider>
  );
};
